import { ClassNameMap, FormControlLabelProps } from '@mui/material';
import { makeStyles  } from 'tss-react/mui';

export type ButtonStyleProps = {
  classes?: ClassNameMap<'buttonStyle' | 'checkbox' | 'selected'>;
  color?: 'primary' | 'secondary';
  noButton?: boolean;
};

export const useControlClasses = makeStyles<{ classes?: FormControlLabelProps['classes']} >()({
  label: {
    width: '100%',
  }
});

export const useStyles = makeStyles<ButtonStyleProps>()((theme, { noButton, color }) => ({
  buttonStyle: {
    border: '1px solid rgba(0, 0, 0, 0.23)',
    margin: theme.spacing(0, 0, 2, 0),
    padding: theme.spacing(2, 3, 2, 1.5),
  },
  checkbox: {
    margin: 0,
    marginRight: noButton ? undefined : theme.spacing(1.5),
    padding: noButton ? undefined : 0,
    '&:hover': {
      backgroundColor: 'transparent',
    }
  },
  otherInput: {
    width: '100%',
    '& input::placeholder': {
      fontStyle: 'italic'
    }
  },
  otherSelected: {
    backgroundColor: color
      ? theme.palette[color].background
      : undefined,
    borderColor: color
      ? theme.palette[color].main
      : undefined,
    color: color
      ? theme.palette[color].dark
      : undefined,
    '& button': {
      display: 'none'
    },
    '&:focus-within': {
      backgroundColor: '#fff',
      '& button': {
        display: 'block'
      }
    }
  },
  selected: {
    backgroundColor: color
      ? theme.palette[color].background
      : undefined,
    borderColor: color
      ? theme.palette[color].main
      : undefined,
    color: color
      ? theme.palette[color].dark
      : undefined
  },
  checkboxOffset: {
    width: '36px'
  }
}));
